import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, ListViewComponent, TranslationPipe } from '@prekog/common-ui';
import { GetProductsResponse } from './get-products.response';
import { Material } from './material.model';
import { UpdateProductsOrderRequest } from './update-products-order.request';

@Component({
    selector: 'pf-existingproducts',
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, DragDropModule, MatIconModule, FormsModule, TranslationPipe, ListViewComponent, ListViewComponent]
})
export class ProductListComponent implements OnInit {
    filteredBooks: Material[] = [];

    placeHolder = 'Szerző, cím';

    products: Material[] = [];

    searchText = '';

    storeBaseUrl = '';

    storeExistingProductsURI = '/store/get-products';

    updateProductsOrderUrl = '/admin/updateProductsOrder';

    constructor(
        private _router: Router,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService) {
        this.storeBaseUrl = _storeBaseUrl;
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else if (sessionStorage.getItem('token')) {
            this._apiRequestService.sendRequest(this.storeBaseUrl, {}, true, this.storeExistingProductsURI).subscribe((response) => {
                const products = response as GetProductsResponse;
                this.products = products.productList as Material[];
                this.filteredBooks = this.products;
            });
        }
    }

    drop(event: CdkDragDrop<Material[]>): void {
        moveItemInArray(this.products, event.previousIndex, event.currentIndex);
    }

    updateProductsOrder() {
        const productsSize = this.products.length;
        const updateProductsOrderRequest: UpdateProductsOrderRequest = {
            productOrderDTO: this.products.map((product, index) => ({
                routerLink: product.routerLink,
                orderNumber: productsSize - index
            }))
        };

        this._apiRequestService
            .sendRequest<
                UpdateProductsOrderRequest,
                HttpResponse<any>
            >(this.storeBaseUrl, updateProductsOrderRequest, true, this.updateProductsOrderUrl, true)
            .subscribe();
    }

}
